// Load all the channels within this directory and make the consumer available globally.
// Channel files must be named *_channel.js.

import consumer from "./consumer"

// Make consumer available globally for Alpine.js and other components
window.consumer = consumer

export default consumer
